import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      token: '',
      adress: 'https://pwi.progen-bot.de/api'
  },
  mutations: {
    setToken(state, newToken) {
      state.token = newToken
    }
  },
  actions: {

  }
})
